import React, { Component } from 'react'

import { Provider } from 'react-redux';
import store from '../../../store'
import { themeMaterial } from '../../../ConfigAplication'
import Layout from '../Layout'
import { BrowserRouter as Router } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles';

class MainMaterial extends Component {
    render() {
        return (
            <MuiThemeProvider theme={themeMaterial}>
                <Provider store={store}>
                      
                    <Router>
                        <Layout />
                    </Router>
                </Provider>
            </MuiThemeProvider>
        )
    }
}


export default MainMaterial


// WEBPACK FOOTER //
// ./src/App/components/App/App.js